export default __webpack_public_path__ + "static/media/runkeeper-track-after-1.2109cff6.svg";